import { api } from '@/config/api';

export type CustomFieldEntityType = 'contact' | 'deal' | 'lead';
export type CustomFieldKind =
  | 'text' | 'long_text' | 'number' | 'currency' | 'date' | 'datetime'
  | 'dropdown' | 'multi_select' | 'boolean' | 'url' | 'phone' | 'email';

export interface CustomFieldDefinition {
  _id: string;
  fieldUid: string;
  companyUid: string;
  entityType: CustomFieldEntityType;
  name: string;
  key: string;
  kind: CustomFieldKind;
  options: string[];
  required: boolean;
  order: number;
  helpText?: string;
  placeholder?: string;
  defaultValue?: string;
  isActive: boolean;
}

export interface UpsertCustomFieldInput {
  name: string;
  key?: string;
  kind: CustomFieldKind;
  options?: string[];
  required?: boolean;
  order?: number;
  helpText?: string;
  placeholder?: string;
  defaultValue?: string;
}

const BASE = '/slighter_crm/custom-fields';

export const customFieldsService = {
  list: async (entityType: CustomFieldEntityType): Promise<CustomFieldDefinition[]> =>
    (await api.get(`${BASE}/${entityType}`)).data,

  create: async (entityType: CustomFieldEntityType, input: UpsertCustomFieldInput): Promise<CustomFieldDefinition> =>
    (await api.post(`${BASE}/${entityType}`, input)).data,

  update: async (fieldUid: string, input: Partial<UpsertCustomFieldInput> & { isActive?: boolean }): Promise<CustomFieldDefinition> =>
    (await api.patch(`${BASE}/${fieldUid}`, input)).data,

  remove: async (fieldUid: string): Promise<{ ok: boolean }> =>
    (await api.delete(`${BASE}/${fieldUid}`)).data,
};
